import { render, staticRenderFns } from "./CytomineTable.vue?vue&type=template&id=72fe82f8"
import script from "./CytomineTable.vue?vue&type=script&lang=js"
export * from "./CytomineTable.vue?vue&type=script&lang=js"
import style0 from "./CytomineTable.vue?vue&type=style&index=0&id=72fe82f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports